import { computed, unref, type MaybeRef } from 'vue'
import { getFullscreenChatHref } from './get-fullscreen-chat-href'

export function useFullscreenChatHref(chatId: MaybeRef<string | number>, messageId?: MaybeRef<string | number>) {
  const href = computed(() => getFullscreenChatHref(unref(chatId), unref(messageId)))
  return href
}
